<div style="display: flex; flex-direction: column; height: 100%;">
    <div class="modal-header">
        <h4 class="modal-title synchpc-primary" id="modal-title">Privacy Policy</h4>
        <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" mat-dialog-close title="Close"></i>
    </div>
    <div class="modal-body" *ngIf="toShowLabel" [ngStyle]="{ 'overflow-y': toShowLabel ? 'hidden' : 'scroll'}">
        <iframe
          src="../../../../../assets/documents/privacy.pdf"
          frameBorder="0"
          scrolling="auto"
          height="100%"
          width="100%"
      ></iframe>
    </div>
    <div class="modal-body" *ngIf="!toShowLabel">
      <p>This privacy policy has been compiled to better serve those who are 
        concerned with how their 'Personally Identifiable Information' (PII)
        is being used online. PII, as described in US privacy law and information
        security, is information that can be used on its own or with other information
        to identify, contact, or locate a single person, or to identify an individual
        in context. Please read our privacy policy carefully to get a clear understanding
        of how we collect, use, protect or otherwise handle your Personally Identifiable
        Information in accordance with our website.</p>
    
        <div class='ppText'>
          This privacy policy has been compiled to better serve those who are 
          concerned with how their 'Personally Identifiable Information' (PII)
          is being used online. PII, as described in US privacy law and information
          security, is information that can be used on its own or with other information
          to identify, contact, or locate a single person, or to identify an individual
          in context. Please read our privacy policy carefully to get a clear understanding
          of how we collect, use, protect or otherwise handle your Personally Identifiable
          Information in accordance with our website.
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Information Collection
          </h4>
          <br>
          <p class='ppText'>
              <strong>
                  What personal information do we collect from the people
                  that visit our blog, website or app?
              </strong>
          </p>
          <p class='ppText'>
              When ordering or registering on our site, as appropriate,
              you may be asked to enter your name, email address,
              mailing address, phone number  or other details 
              to help you with your experience.
          </p>
          <p class='ppText'>
              <strong>
                  When do we collect information?
              </strong>
          </p>
          <p class='ppText'>
              We collect information from you when you register on our site,
              place an order, Open a Support Ticket or enter information on our site.
          </p>
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Information Usage
          </h4>
          <br>
          <p class='ppText'>
              <strong>
                  How do we use your information?
              </strong>
          </p>
          <p class='ppText'>
              We may use the information we collect from you when you register,
              make a purchase, sign up for our newsletter, respond to a survey or
              marketing communication, surf the website, or use certain other
              site features in the following ways:
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong>
              To personalize your experience and to allow us to deliver the
              type of content and product offerings in which you are most interested.
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong>
              To improve our website in order to better serve you.
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong> 
              To allow us to better service you in responding to your customer service requests.
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong> 
              To quickly process your transactions.
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong> 
              To send periodic emails regarding your order or other products and services.
          </p>
          <br/>
          <p class='ppText'>
              <strong>
                  We collect your email address in order to:
              </strong>
          </p>
          <div class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong>
              Send information, respond to inquiries, and/or other requests or questions
          </div>
          <div class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong> 
              Process orders and to send information and updates pertaining to orders.
          </div>
          <div class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong> 
              Send you additional information related to your product and/or service
          </div>
          <div class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong> 
              Market to our mailing list or continue to send emails to 
              our clients after the original transaction has occurred.
          </div>
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Information Protection
          </h4>
          <br>
          <p class='ppText'>
              <strong>
                  How do we protect your information?
              </strong>
          </p>
          <p class='ppText'>
              We adopt appropriate data collection, storage and processing practices
              and security measures to protect against unauthorized access, alteration,
              disclosure or destruction of your personal information, username, password,
              transaction information and data stored on our Site.
          </p>
          <p class='ppText'>
              We implement a variety of security measures when a user places
              an order enters, submits, or accesses their information to maintain
              the safety of your personal information.
          </p>
          <p class='ppText'>
              All transactions are processed through a gateway provider and
              are not stored or processed on our servers.
          </p>
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Cookie Usage
          </h4><br>
          <p class='ppText'>
              <strong>
                  Do we use 'cookies'?
              </strong>
          </p>
          <p class='ppText'>
              Yes. Cookies are small files that a site or its service provider
              transfers to your computer's hard drive through your Web browser
              (if you allow) that enables the site's or service provider's systems
              to recognize your browser and capture and remember certain information.
              For instance, we use cookies to help us remember and process the items
              in your shopping cart. They are also used to help us understand your
              preferences based on previous or current site activity, which enables
              us to provide you with improved services. We also use cookies to help
              us compile aggregate data about site traffic and site interaction so
              that we can offer better site experiences and tools in the future.
          </p>
          <p class='ppText'>
              <strong>
                  We use cookies to:
              </strong>
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong>&bull;</strong>
              Help remember and process the items in the shopping cart.
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong> 
              Understand and save user's preferences for future visits.
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong>
              Compile aggregate data about site traffic and site interactions
              in order to offer better site experiences and tools in the future.
              We may also use trusted third-party services that track this 
              information on our behalf.
          </p>
          <p class='ppText'>
              You can choose to have your computer warn you each time a
              cookie is being sent, or you can choose to turn off all cookies.
              You do this through your browser settings. Since browser is a
              little different, look at your browser's Help Menu to learn the
              correct way to modify your cookies.
          </p>
          <p class='ppText'>
              If you turn cookies off, some features will be disabled.
              It won't affect the user's experience that make your site
              experience more efficient and may not function properly.
          </p>
          <p class='ppText'>
              However, you will still be able to place orders.
          </p>
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Third Party Disclosure
          </h4>
          <br>
          <p class='ppText'>
              We do not sell, trade, or otherwise transfer to outside parties
              your Personally Identifiable Information unless we provide users 
              with advance notice. This does not include website hosting partners
              and other parties who assist us in operating our website, conducting
              our business, or serving our users, so long as those parties agree
              to keep this information confidential. We may also release information
              when it's release is appropriate to comply with the law, enforce our site 
              policies, or protect ours or others' rights, property or safety.
              However, non-personally identifiable visitor information may be provided
              to other parties for marketing, advertising, or other uses.
          </p>
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Third Party Links
          </h4>
          <br>
          <p class='ppText'>
              Occasionally, at our discretion, we may include or offer
              third-party products or services on our website.
              These third-party sites have separate and independent privacy policies.
              We therefore have no responsibility or liability for the content and
              activities of these linked sites. Nonetheless, we seek to protect the
              integrity of our site and welcome any feedback about these sites.
          </p>
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Google AdSense
          </h4>
          <br>
          <p class='ppText'>
              Google's advertising requirements can be summed up by
              Google's Advertising Principles. They are put in place to
              provide a positive experience for users.
              https://support.google.com/adwordspolicy/answer/1316548?hl=en
          </p>
          <p class='ppText'>
              We have not enabled Google AdSense on our site
              but we may do so in the future.
          </p>
          <p class='ppText'>
              Our Privacy Policy link includes the word 'Privacy' and can be
              easily be found on the page specified above.
          </p>
          <p class='ppText'>
              You will be notified of any Privacy Policy changes:
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <strong>&bull;</strong>
              On our Privacy Policy Page 
          </p>
          <p class='ppText'>
              Can change your personal information:
          </p>
          <p class='ppText'>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
              <strong>&bull;</strong>
              By emailing us
          </p>
      </div>
      <div>
        <br><br>
          <h4 class='ppBody col-2'>
              Changes and Acceptance
          </h4><br>
          <p class='ppText'>
              <strong>
                  Changes to this privacy policy
              </strong>
          </p>
          <p class='ppText'>
              Syncious has the discretion to update this privacy policy
              at any time. When we do, we will revise the updated date at
              the bottom of this page. We encourage Users to frequently check
              this page for any changes to stay informed about how we are helping 
              to protect the personal information we collect. 
              You acknowledge and agree that it is your responsibility to review 
              this privacy policy periodically and become aware of modifications.
          </p>
          <p class='ppText'>
              <strong>
                  Your acceptance of these terms
              </strong>
          </p>
          <p class='ppText'>
              By using this Site, you signify your acceptance of this policy.
              If you do not agree to this policy, please do not use our Site.
              Your continued use of the Site following the posting of changes
              to this policy will be deemed your acceptance of those changes.
          </p>
          <p class='ppText'>
              If there are any questions regarding this privacy policy,
              you may contact us at info&#64;syncious.com
          </p>
          <p class='ppText'>
              Last Edited on: 2016-09-03
          </p>  
      </div> 
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" mat-dialog-close cdkFocusInitial>Close</button>
    </div>
</div>